/* ======================
   Quantity Buttons
====================== */
function increaseQty() {
  const input = document.getElementById("quantity");
  input.value = parseInt(input.value) + 1;
}

function decreaseQty() {
  const input = document.getElementById("quantity");
  if (parseInt(input.value) > 1) {
    input.value = parseInt(input.value) - 1;
  }
}

/* ======================
   FAQ Accordion
====================== */
document.querySelectorAll(".faq-question").forEach((btn) => {
  btn.addEventListener("click", () => {
    const item = btn.parentElement;

    document.querySelectorAll(".faq-item").forEach((i) => {
      if (i !== item) i.classList.remove("active");
    });

    item.classList.toggle("active");
  });
});

/* ======================
   Water Difference Slider
====================== */
document.querySelectorAll(".water-diff-container").forEach((container) => {
  const slider = container.querySelector(".slider");
  const waterDiff = container.querySelector(".water-differnce");

  slider.addEventListener("input", (e) => {
    const value = e.target.value;

    waterDiff.style.setProperty("--position", `${value}%`);
    container.setAttribute(
      "data-position",
      value > 50 ? "right" : "left"
    );
  });
});

/* ======================
   See More / See Less
====================== */
const seeMoreBtn = document.querySelector(".btn-see-more");
const featureItems = document.querySelectorAll(".feature-item");
let expanded = false;

featureItems.forEach((item, index) => {
  if (index >= 3) item.classList.add("hidden");
});

if (seeMoreBtn) {
  seeMoreBtn.addEventListener("click", () => {
    expanded = !expanded;

    featureItems.forEach((item, index) => {
      if (index >= 3) {
        item.classList.toggle("hidden", !expanded);
      }
    });

    seeMoreBtn.textContent = expanded ? "See less" : "See more";
  });
}

/* ======================
   Image Gallery Thumbnails
====================== */
const thumbnails = document.querySelectorAll(".thumbnail");
const mainImage = document.getElementById("mainImage");

thumbnails.forEach((thumbnail) => {
  thumbnail.addEventListener("click", function () {
    thumbnails.forEach((thumb) => thumb.classList.remove("active"));
    this.classList.add("active");

    const newImageSrc = this.getAttribute("data-image");

    gsap.to(mainImage, {
      opacity: 0,
      duration: 0.2,
      onComplete: () => {
        mainImage.src = newImageSrc;
        gsap.to(mainImage, {
          opacity: 1,
          duration: 0.3,
          ease: "power2.out",
        });
      },
    });
  });
});

/* ======================
   GSAP Water Animation
====================== */
const imageContainer = document.querySelector(".image-container");
const waterImage = document.querySelector(".water-image");
const water = document.querySelector(".water");
const step1 = document.querySelector(".step-1");
const step2 = document.querySelector(".step-2");
const step3 = document.querySelector(".step-3");

function getResponsiveValues() {
  const width = window.innerWidth;

  if (width >= 1200) {
    return {
      rotation1: 65,
      rotation2: 45,
      rotation3: 25,
      x2: -200,
      y2: 600,
      scale2: 2,
      x3: -200,
      scale3: 1.5,
      x4: -300,
      y4: -400,
      scale4: 1.5,
    };
  } else if (width >= 768) {
    return {
      rotation1: 45,
      rotation2: 35,
      rotation3: 20,
      x2: -100,
      y2: 300,
      scale2: 1.5,
      x3: -100,
      scale3: 1.3,
      x4: -150,
      y4: -200,
      scale4: 1.3,
    };
  } else {
    return {
      rotation1: 30,
      rotation2: 25,
      rotation3: 15,
      x2: -50,
      y2: 150,
      scale2: 1.3,
      x3: -50,
      scale3: 1.2,
      x4: -80,
      y4: -100,
      scale4: 1.2,
    };
  }
}

let timeline;

function createTimeline() {
  const values = getResponsiveValues();
  const totalDuration = 7;

  if (timeline) timeline.kill();

  gsap.set([waterImage, step1, step2, step3, water], { clearProps: "all" });
  gsap.set([step1, step2, step3, water], {
    opacity: 0,
    visibility: "hidden",
  });

  timeline = gsap.timeline({ paused: true });

  timeline
    .to(waterImage, {
      rotation: values.rotation1,
      duration: totalDuration * 0.2,
      ease: "power2.inOut",
    })
    .to(waterImage, {
      rotation: values.rotation2,
      x: values.x2,
      y: values.y2,
      scale: values.scale2,
      duration: totalDuration * 0.2,
      ease: "power2.inOut",
    })
    .to(step1, {
      opacity: 1,
      visibility: "visible",
      duration: 0.6,
    }, totalDuration * 0.4)
    .to(waterImage, {
      rotation: values.rotation3,
      x: values.x3,
      scale: values.scale3,
      duration: totalDuration * 0.2,
    }, totalDuration * 0.4)
    .to(step1, { opacity: 0 }, totalDuration * 0.6)
    .to(step2, { opacity: 1, visibility: "visible" }, totalDuration * 0.6)
    .to(waterImage, {
      rotation: 0,
      x: values.x4,
      y: values.y4,
      scale: values.scale4,
    }, totalDuration * 0.6)
    .to(step2, { opacity: 0 }, totalDuration * 0.8)
    .to(step3, { opacity: 1, visibility: "visible" }, totalDuration * 0.8)
    .to(water, { opacity: 1, visibility: "visible" }, totalDuration * 0.8);
}

createTimeline();

/* Hover / Touch Controls */
if ("ontouchstart" in window) {
  imageContainer.addEventListener("click", () => {
    timeline.progress() === 0 || timeline.progress() === 1
      ? timeline.restart()
      : timeline.reverse();
  });
} else {
  imageContainer.addEventListener("mouseenter", () => timeline.restart());
  imageContainer.addEventListener("mouseleave", () => timeline.reverse());
}

window.addEventListener("resize", () => {
  clearTimeout(window._resizeTimer);
  window._resizeTimer = setTimeout(createTimeline, 250);
});
